<label
  *ngIf="!fileName"
  class="file-upload"
  [for]="id"
  [ngClass]="{ 'drag-file-area': isHoverFile }"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  (dragleave)="onDragLeave($event)"
>
  <div class="file-upload-body">
    <div class="file-upload-body-icon">
      <img alt="add" src="/assets/icons/icon_add_lg.svg" />
    </div>
    <div class="file-upload-body-text" [innerHTML]="header | translate"></div>
    <div class="file-upload-body-hint" [innerHTML]="headerHint | translate"></div>
  </div>

  <div class="file-upload-footer" [innerHTML]="footerHint | translate"></div>

  <loading-spinner [show]="isLoading || isUploadingDoc"></loading-spinner>
</label>

<input
  *ngIf="!fileName"
  #inputElement
  class="d-none"
  type="file"
  [multiple]="isMultiple"
  [id]="id"
  [disabled]="!!fileName"
  [accept]="allowedFileMimes.join(',')"
  (click)="clickInput()"
  (change)="handleFiles($event)"
/>
<app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>

<ng-template [ngIf]="fileName">
  <div class="file-uploaded">
    <loading-spinner [show]="isLoading || isUploadingDoc"></loading-spinner>

    <div class="file-uploaded-body" [ngClass]="{ 'file-uploaded-body-is-list': isList, 'is-last': isLast }">
      <div class="file-uploaded-body-left">
        <div class="file-uploaded-body-icon">
          <img alt="added" src="/assets/icons/icon_file_uploaded.svg" />
        </div>

        <div class="file-uploaded-body-text">
          <div class="file-uploaded-body-text-name" *ngIf="!!headerUploaded" [innerHTML]="headerUploaded | translate"></div>
          <div class="file-uploaded-body-text-file">{{ fileName }}</div>
        </div>
      </div>

      <div class="file-uploaded-body-delete">
        <img alt="delete" src="/assets/icons/icon_trash.svg" class="file-uploaded-body-delete-icon" (click)="removeFile()" />
      </div>
    </div>
  </div>
</ng-template>
